export const SCATTER_POINT_SIZE = 3;
export const SCATTER_POINT_SIZE_FOR_NESTING = 30;
export const SCATTER_POINT_OPACITY = 1;
export const SCATTER_POINT_STROKE = "black";
export const SCATTER_POITN_STROKE_WIDTH = 0;

export const CROSS_SYMBOL_D3 =
  "M-5.366563145999495,-1.7888543819998317" +
  "L-1.7888543819998317,-1.7888543819998317" +
  "L-1.7888543819998317,-5.366563145999495" +
  "L1.7888543819998317,-5.366563145999495" +
  "L1.7888543819998317,-1.7888543819998317" +
  "L5.366563145999495,-1.7888543819998317" +
  "L5.366563145999495,1.7888543819998317" +
  "L1.7888543819998317,1.7888543819998317" +
  "L1.7888543819998317,5.366563145999495" +
  "L-1.7888543819998317,5.366563145999495" +
  "L-1.7888543819998317,1.7888543819998317" +
  "L-5.366563145999495,1.7888543819998317Z";

export const CROSS_SYMBOL =
  "M-5.366563145999495,-1.007888543819998317" +
  "L-1.007888543819998317,-1.007888543819998317" +
  "L-1.007888543819998317,-5.366563145999495" +
  "L1.007888543819998317,-5.366563145999495" +
  "L1.007888543819998317,-1.007888543819998317" +
  "L5.366563145999495,-1.007888543819998317" +
  "L5.366563145999495,1.007888543819998317" +
  "L1.007888543819998317,1.007888543819998317" +
  "L1.007888543819998317,5.366563145999495" +
  "L-1.007888543819998317,5.366563145999495" +
  "L-1.007888543819998317,1.007888543819998317" +
  "L-5.366563145999495,1.007888543819998317Z";



// WEBPACK FOOTER //
// ./src/components/visualizations/scatterplots/default-design.ts